// Small helpers so we only depend on the core @atlaskit/pragmatic-drag-and-drop package.
 
// Which half of the element the pointer is over.
// direction: 'vertical' -> 'top' | 'bottom', 'horizontal' -> 'left' | 'right'
export function getClosestEdge(input, element, direction = 'vertical') {
  const rect = element.getBoundingClientRect();
  if (direction === 'horizontal') {
    return input.clientX < rect.left + rect.width / 2 ? 'left' : 'right';
  }
  return input.clientY < rect.top + rect.height / 2 ? 'top' : 'bottom';
}
 
// Final index when moving an item inside the SAME list.
export function getReorderDestinationIndex({ startIndex, indexOfTarget, closestEdgeOfTarget }) {
  if (startIndex === -1 || indexOfTarget === -1) return startIndex;
  if (startIndex === indexOfTarget) return startIndex;
  if (closestEdgeOfTarget == null) return indexOfTarget;
 
  const isGoingAfter = closestEdgeOfTarget === 'bottom' || closestEdgeOfTarget === 'right';
  if (startIndex < indexOfTarget) {
    return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
  }
  return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}